import { Reveal } from '../components/Reveal';
import { ServiceCard } from '../components/ServiceCard';
import { TrustBadges } from '../components/TrustBadges';
import { FAQSection } from '../components/FAQSection';
import { SERVICES } from '../lib/site';

const ServicesPage = ({ onOpenQuote }) => {
    return (
        <main data-testid="services-page">
            <section className="pt-16 md:pt-24 pb-16 border-b border-border">
                <div className="container-axion">
                    <Reveal>
                        <div className="overline">What we do</div>
                        <h1 className="font-outfit font-medium tracking-tight mt-4 text-5xl md:text-6xl lg:text-[5rem] leading-[1.02] max-w-4xl">
                            Five services. <em className="italic font-light text-accent">One uncompromising standard.</em>
                        </h1>
                        <p className="mt-7 max-w-2xl text-muted-foreground text-lg leading-relaxed">
                            Whether it's a weekly home visit or a high-stakes inventory clean, we approach every job
                            with the same checklist-led care.
                        </p>
                    </Reveal>
                </div>
            </section>

            <section className="py-20 md:py-28">
                <div className="container-axion grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {SERVICES.map((s, i) => (
                        <Reveal key={s.slug} delay={i * 90}>
                            <ServiceCard service={s} onQuote={onOpenQuote} />
                        </Reveal>
                    ))}
                </div>
            </section>

            <section className="py-16 border-t border-border bg-white">
                <div className="container-axion">
                    <TrustBadges />
                </div>
            </section>

            <FAQSection />
        </main>
    );
};

export default ServicesPage;
